import type { CategoryIdentifier } from "@opensea/graphql"
import {
  AccountCircle,
  Brush,
  Camera,
  MusicNote,
  StadiaController,
  WorkspacePremium,
} from "@opensea/ui-kit/icons"

export const COMPANY_ADDRESS =
  "228 Park Avenue South, #22014, New York, NY 10003"
export const TERMS_OF_SERVICE_POSTED_DATE = "September 14, 2025"
export const WALLET_TERMS_OF_USE_POSTED_DATE = "December 1, 2023"
export const SUPPORT_URL = "https://support.opensea.io/"
export const TAX_RESOURCES_URL = "https://opensea.io/tax-resources"
export const DISCORD_URL = "https://discord.gg/opensea"
export const LEARN_URL = "https://opensea.io/learn"
export const BLOG_URL = "https://opensea.io/blog"
export const X_USERNAME = "opensea"
export const TELEGRAM_USERNAME = "officialopensea"
export const INSTAGRAM_USERNAME = "opensea"
export const PRIVACY_POLICY_URL = "/privacy"
export const TERMS_OF_SERVICE_URL = "/tos"
export const DEVELOPER_DOCS_URL =
  "https://docs.opensea.io/reference/api-overview"
export const DEVELOPER_MCP_DOCS_URL = "https://docs.opensea.io/docs/mcp"
export const DEVELOPER_TERMS_URL = "/developer-terms"
export const PRIVY_TERMS_URL = "https://www.privy.io/user-terms-of-service"
export const CRYPTO_PUNKS_ADDRESS = "0xb47e3cd837ddf8e4c57f05d70ab865de6e193bbb"
export const ENS_WRAPPER_ADDRESS = "0xd4416b13d2b3a9abae7acd5d6c2bbdbe25686401"

export const ETH_DECIMALS = 18
export const REFETCH_TIMEOUT_MS = 1000

export const CATEGORIES = [
  { identifier: "GAMING", icon: StadiaController },
  { identifier: "ART", icon: Brush },
  { identifier: "PFPS", icon: AccountCircle },
  { identifier: "MEMBERSHIPS", icon: WorkspacePremium },
  { identifier: "MUSIC", icon: MusicNote },
  { identifier: "PHOTOGRAPHY", icon: Camera },
] as const

export type Category = (typeof CATEGORIES)[number]
type DefinedCategoryIdentifier = Category["identifier"]

const CATEGORY_IDENTIFIERS = new Set(CATEGORIES.map(x => x.identifier))

export function isDefinedCategoryIdentifier(
  category: CategoryIdentifier,
): category is DefinedCategoryIdentifier {
  return CATEGORY_IDENTIFIERS.has(category as DefinedCategoryIdentifier)
}

// Limit the amount we pre-build
export const PRIORITY_CATEGORIES = CATEGORIES.slice(0, 4)

/** Temporary FE list until added to BE as `isBulkActionEnabled` */
export const isBulkActionEnabled = (collectionSlug: string | undefined) =>
  !BULK_ACTION_DISABLED_COLLECTIONS.includes(collectionSlug ?? "")
const BULK_ACTION_DISABLED_COLLECTIONS = ["chonks"]

export const SOLANA_NULL_ADDRESS = "11111111111111111111111111111111"
